import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  CHECK_NDC_CPT_COMPATIBILITY_REQUEST: '',
  CHECK_NDC_CPT_COMPATIBILITY_SUCCESS: '',
  CHECK_NDC_CPT_COMPATIBILITY_FAILURE: '',

  CHECK_BULK_NDC_CPT_COMPATIBILITY_REQUEST: '',
  CHECK_BULK_NDC_CPT_COMPATIBILITY_SUCCESS: '',
  CHECK_BULK_NDC_CPT_COMPATIBILITY_FAILURE: '',

  GET_RELATED_NDC_REQUEST: '',
  GET_RELATED_NDC_SUCCESS: '',
  GET_RELATED_NDC_FAILURE: '',

  GET_NDC_CODE_REQUEST: '',
  GET_NDC_CODE_SUCCESS: '',
  GET_NDC_CODE_FAILURE: '',

  GET_NDC_REQUIRED_REQUEST: '',
  GET_NDC_REQUIRED_SUCCESS: '',
  GET_NDC_REQUIRED_FAILURE: '',
};

types = setStoreTypeValues(types, 'claimNDC');

export default types;
